import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from '../../icon'
import Typography from '../../typography'

import { useBreakpoint } from '../../../../hooks/breakpoint'

import ArrowDown from '../../icon/arrow-down.svg'

const Header = ({ preTitle, title, text, image, nearestTransmission, recordedSectionID, ...attrs }) => {
  const breakpoint = useBreakpoint()

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-8',
      'md:pt-0',
      'bg-yellow-600'
    ]
  )

  const goToRecordedWebinars = () => {
    if (typeof window !== 'undefined') {
      const recordedSection = document.getElementById(recordedSectionID)
      recordedSection.scrollIntoView()
    }
  }

  return <section {...attrs}>
    <div
      className={
        classNames([
          breakpoint.mdAndUp ? '' : 'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            'items-center',
            '-mx-4'
          ])
        }
        style={
          {
            minHeight: '25rem'
          }
        }>
        <div
          className={
            classNames([
              'relative',
              'px-4',
              'pb-6',
              'pt-12',
              'md:pb-12',
              'md:pt-24',
              'flex',
              'flex-col',
              'justify-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%'
          }}>
          <Typography
            size={breakpoint.mdAndUp ? 'four' : 'tree'}
            weight={'medium'}
            className={'text-red-500 mb-2'}>
            {preTitle}
          </Typography>

          <Typography
            size={breakpoint.mdAndUp ? 'eight' : 'six'}
            weight={'black'}
            className={'text-red-500 mb-2'}>
            {title}
          </Typography>

          <Typography
            size={breakpoint.mdAndUp ? 'three' : 'two'}
            className={'text-red-500 mb-6'}>
            {text}
          </Typography>

          <div
            className={
              classNames([
                'p-3',
                'w-full',
                'flex',
                'items-center',
                'justify-center',
                'cursor-pointer',
                'bg-red-500',
                'text-yellow-500',
                'hover:bg-red-400',
                'active:bg-red-600'
              ])
            }
            style={{
              maxWidth: '20rem',
              borderRadius: '0 1.5rem 1.5rem 1.5rem'
            }}
            onClick={goToRecordedWebinars}>
            <Typography
              size={breakpoint.mdAndUp ? 'three' : 'two'}>
              Ver webinars
            </Typography>
            <Icon
              width={20}
              height={20}
              svg={ArrowDown}
              className={'ml-2'} />
          </div>
        </div>
        <div
          className={
            classNames([
              breakpoint.mdAndUp ? 'absolute' : '',
              breakpoint.mdAndUp ? 'top-0' : '',
              breakpoint.mdAndUp ? 'bottom-0' : '',
              breakpoint.mdAndUp ? 'left-1/2' : '',
              breakpoint.mdAndUp ? 'right-0' : '',
              'flex',
              'flex-col',
              'justify-center',
              'items-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%',
            height: breakpoint.mdAndUp ? '100%' : '18rem'
          }}>
          <div
            className={
              classNames([
                'bg-cover',
                'bg-center',
                'h-full',
                'w-full'
              ])
            }
            style={{
              borderRadius: breakpoint.mdAndUp ? '7.5rem 0 0 0' : '0',
              backgroundImage: `url('${image.meta.downloadUrl}')`
            }}>
          </div>
        </div>
      </div>
    </div>
  </section>
}

Header.propTypes = {
  preTitle: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.object,
  nearestTransmission: PropTypes.object,
  recordedSectionID: PropTypes.string
}

export default Header
